import { render, staticRenderFns } from "./index.vue?vue&type=template&id=09c92cd0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_acadmin_online_docker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09c92cd0')) {
      api.createRecord('09c92cd0', component.options)
    } else {
      api.reload('09c92cd0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=09c92cd0", function () {
      api.rerender('09c92cd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChangeArea/index.vue"
export default component.exports